import React from "react";
import AdminLayout from "./AdminLayout";
import { Box, Typography } from "@mui/material";

const ActivityLogsPage = () => {
  return (
    <AdminLayout>
      <Box>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
          Activity Logs
        </Typography>
        {/* Copy your renderActivityLogs() content from AdminDashboard.js here */}
        <Typography variant="body1" color="text.secondary">
          Activity logs content - move from AdminDashboard.js
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default ActivityLogsPage;
